import React, { useEffect, useState } from 'react';
import { Container} from "reactstrap";
//Import Breadcrumb
import _ from 'lodash'
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { getBusinessListState} from '../../services/api/api-service';
//Import Image
import BusinessDataTable from './ListComponents/BusinessDataTable';
const PackersAndMovers = (props) => {
    const [businessList, setbusinessList] = useState([]);
    const [stateValue, setStateValue] = useState(null);
    useEffect(() => {
        getBusinessListState('Packers And Movers', stateValue).then(data => {
            if (!_.isEmpty(data)) {
                setbusinessList(data)
            }
        })
    }, [stateValue])
   
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Listing" breadcrumbItem="Packers And Movers List" />
                    <BusinessDataTable title={'Register packers and movers list'} listData={businessList}/>             
                </Container>
            </div>
        </React.Fragment>
    );
}
export default PackersAndMovers;